export * from './TamtamAPI/apps'
export * from './TamtamAPI/assignments'
export * from './TamtamAPI/auth';
export * from './TamtamAPI/documents'
export * from './TamtamAPI/eventStats'
export * from './TamtamAPI/mangoPay'
export * from './TamtamAPI/notifications'
export * from './TamtamAPI/payment';
export * from './TamtamAPI/statistics'
export * from './TamtamAPI/paymentLogs'
export * from './TamtamAPI/user'
export * from "./TamtamAPI/webinarStats";


// WEBPACK FOOTER //
// ./app/api/index.js